import {
    ColoursObj,
    Icon,
    TEventrIcons,
    Typography,
    getContrastYIQ,
} from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { ReactNode } from 'react'

export default function SlideCardRow({
    iconKey,
    label,
    children,
    action,
    toolbar,
    underlined,
    iconBackgroundColor,
}: {
    iconKey: TEventrIcons
    label?: string
    action: () => void
    toolbar?: ReactNode
    underlined?: boolean
    children?: ReactNode
    iconBackgroundColor?: string
}) {
    return (
        <Stack
            direction="row"
            paddingTop="8px"
            paddingBottom="8px"
            justifyContent={label ? 'space-between' : 'start'}
            width="100%"
            onClick={(event) => {
                event.stopPropagation()

                action()
            }}
        >
            <Stack
                direction="row"
                spacing="16px"
                overflow="hidden"
                alignItems="center"
            >
                <Stack
                    bgcolor={
                        iconBackgroundColor || `${ColoursObj.shades.shade5}30`
                    }
                    minWidth="24px"
                    width="24px"
                    height="24px"
                    borderRadius="24px"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Icon
                        height="16px"
                        width="16px"
                        name={iconKey}
                        iconColour={getContrastYIQ(
                            ColoursObj.backgrounds.header
                        )}
                    />
                </Stack>
                {label && (
                    <Typography
                        id="headerLabels"
                        variant="bodyRegular"
                        color={getContrastYIQ(ColoursObj.backgrounds.header)}
                        textOverflow="ellipsis"
                        align="left"
                        overflow="hidden"
                        whiteSpace="nowrap"
                        style={{
                            textDecoration: underlined ? 'underline' : 'none',
                            textUnderlineOffset: '3px',
                        }}
                    >
                        {label}
                    </Typography>
                )}
                {children}
            </Stack>

            {toolbar}
        </Stack>
    )
}
